import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const CarerDashboard = () => {
  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 5 }}>
        <Typography variant="h4" gutterBottom>
          Carer Dashboard
        </Typography>

        <Box mt={2}>
          <Typography variant="body1">
            Welcome, Carer! You can check your daily visits, log care activities, and update progress notes for clients.
          </Typography>

          {/* Future enhancements */}
          {/* <VisitSchedule /> */}
          {/* <CareLog /> */}
        </Box>
      </Paper>
    </Container>
  );
};

export default CarerDashboard;
